export const LIVE_STATS_PATHS = {
  visits: '/api/v1/analytics/visits',
  dashboardSnapshot: '/api/v1/analytics/dashboard-snapshot',
  roomSeries: '/api/v1/analytics/room-series',
  rtcJoinSeries: '/api/v1/analytics/rtc-join-series',
  liveOverview: '/api/v1/analytics/live-overview',
  liveFailureOverview: '/api/v1/analytics/live-failure-overview',
  stream: '/api/v1/visits/stream',
  enter: '/api/v1/visits/events/enter',
  ping: '/api/v1/visits/events/ping',
  exit: '/api/v1/visits/events/exit',
}

export const LEGACY_LIVE_STATS_PATHS = {
  visits: '/stats/visits',
  dashboardSnapshot: '/stats/dashboard_snapshot',
  roomSeries: '/stats/room_series',
  rtcJoinSeries: '/stats/rtc_join_series',
  liveOverview: '/stats/live_overview',
  liveFailureOverview: '/stats/live_failure_overview',
  stream: '/stats/stream',
  enter: '/visit/enter',
  ping: '/visit/ping',
  exit: '/visit/exit',
}

export function buildLiveStatsUrl(base = '', path, query = '') {
  const normalizedBase = String(base || '').replace(/\/$/, '')
  const queryString = typeof query === 'string'
    ? query.replace(/^\?/, '')
    : new URLSearchParams(query).toString()

  return `${normalizedBase}${path}${queryString ? `?${queryString}` : ''}`
}

export function unwrapLiveStatsPayload(json) {
  if (json && Object.prototype.hasOwnProperty.call(json, 'data')) {
    return json.data
  }
  return json
}

export async function fetchLiveStatsJson(base, path, query = '', options = {}) {
  const response = await fetch(buildLiveStatsUrl(base, path, query), {
    credentials: 'omit',
    ...(options.fetchOptions || {}),
  })

  if (!response.ok) {
    const error = new Error(`HTTP ${response.status}`)
    error.status = response.status
    throw error
  }

  const json = await response.json()
  if (json && json.code != null && Number(json.code) !== 0) {
    throw new Error(json.message || '直播统计接口返回错误')
  }

  return unwrapLiveStatsPayload(json) || {}
}

export async function fetchLiveStatsJsonWithFallback(base, path, legacyPath, query = '', options = {}) {
  try {
    return await fetchLiveStatsJson(base, path, query, options)
  } catch (error) {
    if (!legacyPath || (error.status !== 404 && error.status !== 405)) {
      throw error
    }
    return fetchLiveStatsJson(base, legacyPath, query, options)
  }
}
